import React, { useState } from 'react';

import Input from '../Input';
import Buttons from '../../../Table/Row/EditableWithButtons/Buttons';

export default function InputWithButtons({
  isNotice,
  formattedValue,
  canFieldBeEdited,
  type,
  value,
  setValue,
  onSubmit,
}) {
  const [isEditing, setIsEditing] = useState(false);

  let content = (
    <div className="pl-1 flex items-center">
      <span className={`${isNotice ? 'font-bold' : ''}`}>{formattedValue}</span>

      <button
        onClick={() => setIsEditing(true)}
        type="button"
        className="text-slate-400 hover:text-slate-500 dark:text-slate-500 dark:hover:text-slate-400 rounded-full"
        style={{
          visibility: canFieldBeEdited ? 'visible' : 'hidden',
        }}
      >
        <span className="sr-only">Edit</span>
        <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32">
          <path d="M19.7 8.3c-.4-.4-1-.4-1.4 0l-10 10c-.2.2-.3.4-.3.7v4c0 .6.4 1 1 1h4c.3 0 .5-.1.7-.3l10-10c.4-.4.4-1 0-1.4l-4-4zM12.6 22H10v-2.6l6-6 2.6 2.6-6 6zm7.4-7.4L17.4 12l1.6-1.6 2.6 2.6-1.6 1.6z" />
        </svg>
      </button>
    </div>
  );

  if (isEditing) {
    content = (
      <div className="pl-1 flex gap-2 items-center flex-col sm:flex-row">
        <Input value={value} setValue={setValue} type={type} />
        <div className="relative top-[2px]">
          <Buttons
            onSubmit={() => {
              onSubmit();
              setIsEditing(false);
            }}
            onCancel={() => setIsEditing(false)}
          />
        </div>
      </div>
    );
  }

  return content;
}
